import initSlickWithArrowEvent from "../../components/slick-utils";

function initShopProductBrandCarouselCollectionsSlick() {
    const slick = initSlickWithArrowEvent(
        $('.maier-wrapper-shop-product-brand-carousel-collections .maier-carousel-list'),
        {
            dots: false,
            dotsClass: 'slick-dots',
            prevArrow: '<span class="slide-arrow prev">Prev</span>',
            nextArrow: '<span class="slide-arrow next">Next</span>',
            autoplay: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        rows: 2,
                        slidesPerRow: 2
                    }
                }
            ]
        }
    );
}

document.addEventListener('DOMContentLoaded', initShopProductBrandCarouselCollectionsSlick);

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length >= 1) {
            initShopProductBrandCarouselCollectionsSlick();
        }
    });
});

observer.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
